export enum RegistrationFieldStatus {
  Empty = 1,
  PendingByAdmin = 2,
  PendingByUser = 3,
  Rejected = 4,
  Verified = 5,
}
